<template>
  <div class="pulse">
    <div class="pulse__main container-router">
      <div class="pulse__main__header">Pulse</div>
      <div class="pulse__main__list">
        <table>
          <thead>
            <tr>
              <td class="header1">LOCATION</td>
              <td class="header1">ADDRESS</td>
              <td class="header2">DEVICE ID</td>
              <td class="header2">LAST PULSE</td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(item, index) in pulses" :key="index">
              <td class="body">
                {{ item.location_name }}
                <p class="sub">{{ item.placement }}</p>
              </td>
              <td class="body">
                {{ item.address }}
                <p class="sub">{{ item.city_name }}</p>
              </td>
              <td class="body">{{ item.id }}</td>
              <td class="body">{{ formatDate(item.pulse) }}</td>
            </tr>
          </tbody>
        </table>
        <!-- <div v-if="!isLoading && !isEmpty">
          <adx-pagination :selectedPage="selectedPage" :maxPage="maxPage"/>
        </div> -->
        <div class="loadingState"><adx-loading v-if="isLoading" slot="loading" /></div>
        <div class="emptyState"><adx-empty-selection v-if="isEmpty && !loading" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDateTime } from '@/lib/util'

export default {
  name: 'adx-admin-pulse',
  components: {
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-pagination': Pagination,
  },
  mounted () {
    this.getLastPulses()
  },
  data() {
    return {
      isLoading: false,
      isEmpty: false,
      selectedPage: 1,
      maxPage: 3,
      pulses: [],
      items: [
        {
          'id': 12345,
          'location_name': 'Surga',
          'city_name': 'Akhirat',
          'address': 'Di Telapak Kaki Ibu',
          'placement': 'Pavilion',
          'pulse': '30 May 2018 12:00:18',
        },
        {
          'id': 66666,
          'location_name': 'Neraka',
          'city_name': 'Akhirat',
          'address': 'Alam Kubur',
          'placement': 'Gerbang Utama',
          'pulse': '06 Jun 2016 12:00:18',
        },
      ]
    }
  },
  methods: {
    formatDate(date){
      return formatShortDateTime(date)
    },
    getLastPulses(){
      (async () => {
        this.isLoading = true
        const { data } = await api.get(apiV2.lastPulses, { needToken: true })
        this.pulses = data
        this.isLoading = false
      })();
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>


